import clsx from 'clsx';
import { Box, Flex, Image, Link, Paragraph, PlainLink } from '@customerio/pluma-components/react';
import logoMint from '@/assets/images/logos/logo-mint.svg';
import * as styles from '../index.css';

type SignupHeaderProps = {
  /** Show the "Already have an account? Log in." callout — the entry step only. */
  showLoginLink?: boolean;
  /** Fires the `Signup: Sign in Clicked` analytics event before navigation. */
  onLoginLinkClick?: () => void;
  /** Forced-dark funnel: swap the brand forest green for charcoal. */
  isDark: boolean;
};

/**
 * Stripped-down header (logo, plus the log-in callout on the entry step) shown
 * across the signup funnel.
 */
export function SignupHeader({ showLoginLink = false, onLoginLinkClick, isDark }: SignupHeaderProps) {
  return (
    <Box
      className={clsx(styles.signupHeader, isDark && styles.signupHeaderDark)}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      position="relative"
      zIndex="header"
      px="300"
    >
      <PlainLink href="https://customer.io" data-test-signup-logo-link>
        <Image alt="Customer.io" src={logoMint} width="129" height="18" verticalAlign="bottom" />
      </PlainLink>

      {showLoginLink ? (
        <Flex>
          <Paragraph color="white">
            Already have an account?{' '}
            <Link href="/login" variant="secondary" isUnderlined onClick={onLoginLinkClick} data-test-signup-login-link>
              Log in
            </Link>
            .
          </Paragraph>
        </Flex>
      ) : null}
    </Box>
  );
}
